var isDev = location.href.indexOf("localhost:") !== -1;
var isSITUAT = location.href.indexOf("-sit") !== -1 || location.href.indexOf("-uat") !== -1;

/** ************** General ************** */
function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const variables = query.split("&");
  for (var i = 0; i < variables.length; i++) {
    var pair = variables[i].split("=");
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  console.log("Query variable %s not found", variable);
}

/** ************** FAQ for desktop **************
 *  mobile load by files, not using hash */
function faqDetectHash() {
  let hash = location.hash.split("#")[1];

  // set 'howToDeposit' section as default if hash does not exist
  if (hash === "" || hash === undefined) {
    hash = "howToDeposit";
  }

  $(`.faq-wrapper .tab-item[data-section="${hash}"]`)
    .addClass("active")
    .siblings(".tab-item")
    .removeClass("active");
  $(`.faq-wrapper .content-item[data-section="${hash}"]`)
    .addClass("active")
    .siblings(".content-item")
    .removeClass("active");
}

/** ************** Document Ready ************** */
$(document).ready(function () {
  if ($(".faq-wrapper").length !== 0) {
    faqDetectHash();

    $(".faq-wrapper .tab-item").on("click", function () {
      location.hash = $(this).data("section");
      faqDetectHash();
    });
  }
});
